// extracted by mini-css-extract-plugin
export default {"paper":"AutocompleteControl_paper__I21JB","inputControl":"AutocompleteControl_inputControl__XGvD5","error":"AutocompleteControl_error__eVbeT"};